import { Event, EventHint } from "@sentry/react";
import shouldSentryLogMessage from "@/V2Utils/commonErrors";

export const beforeSendingEvent = (event: Event, hint?: EventHint) => {
	const updatedEvent = { ...event };

	const extraArguments = updatedEvent?.extra?.arguments as
		| Array<Record<string, string | number>>
		| undefined;

	const errorsWithCode = extraArguments?.filter(
		extra => extra?.code === 400 || extra?.code === 401
	);

	if (!!errorsWithCode?.length) return null;

	const shouldLogMessage = shouldSentryLogMessage(
		updatedEvent?.message ?? "",
		JSON.stringify(
			updatedEvent?.extra?.arguments ?? updatedEvent?.extra ?? ""
		)
	);

	if (!shouldLogMessage) return null;

	if (
		updatedEvent &&
		updatedEvent.logger === "console" &&
		updatedEvent.extra &&
		updatedEvent.message &&
		updatedEvent.message?.includes("[object Object]")
	) {
		try {
			const argsAsJSON = JSON.stringify(
				updatedEvent.extra.arguments
			)?.slice(1, -1);
			updatedEvent.message = argsAsJSON;
		} catch (error) {
			console.error(error);
		}
	}

	updatedEvent.extra = {
		...updatedEvent.extra,
		hint: JSON.stringify(hint)
	};

	return updatedEvent;
};
